import React from 'react';
import styles from '../GenericLoadingScreen/GenericLoadingScreen.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { t } from 'i18next';

export const GenericLoadingScreen = () => {
  const messageKey = 'LoadingApplicationServices';
  let message = t(messageKey);
  message = message === messageKey || !message ? 'Loading Virtual Engineer' : message;
  return (
    <div className={styles['loading-screen']}>
      <div className={styles['loading-gear-div']}>
        <FontAwesomeIcon className={styles['loading-gear-icon']} icon="gears" beatFade />
      </div>
      <div className={styles['loading-text-wrapper']}>{message} ...</div>
    </div>
  );
};
